import React, { useEffect, useState } from 'react';
import autoCheck from '../../common/assets/images/autoCheck.svg';
import marketValue from '../../common/assets/images/marketValue.svg';
import salvageValue from '../../common/assets/images/salvageValue.svg';
import insuranceValue from '../../common/assets/images/insuranceValue.svg';
import linkIcon from '../../common/assets/images/linkIcon.svg';
import { getCarinfoByVin } from '../../utils/api';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const Summary = ({loading,setLoading,vin}) => {
  const [carInfo, setCarInfo] = useState();

  useEffect(() => {
    if (vin) {
      setLoading(true);
      getCarinfoByVin(vin)
        .then((res) => {
          setLoading(false);
          if (res?.data) {
            console.log('res?.data', res?.data);
            setCarInfo(res?.data);
          } else {
            setCarInfo(null);
          }
        })
        .catch(() => setLoading(false));
    }
  }, [vin]);

  return (
    <Spin
      spinning={loading}
      indicator={
        <LoadingOutlined
          style={{
            fontSize: 48,
            color: 'black',
          }}
          spin
        />
      }
    >
      <div>
        <div className='py-[50px]'>
          <div className="bg-[url('/src/common/assets/images/productPageSummary1.png')] p-[113px] bg-no-repeat bg-cover bg-center">
            <div
              style={{ boxShadow: '3px 2px 17px 0px #00000040' }}
              className='bg-white p-8'
            >
              <h2 className='underline font-medium text-xl pb-[40px]'>
              Key Specification
              </h2>
              <div className='flex gap-16 font-normal '>
                <div className='text-lg w-1/2'>
                  <div className='flex justify-between border-b-[0.5px] border-[#7D7D7D] pb-3 mb-8'>
                    <p>Brand Name</p>
                    <p>{carInfo?.make?.name}</p>
                  </div>
                  <div className='flex justify-between border-b-[0.5px] border-[#7D7D7D] pb-3 mb-8 capitalize'>
                    <p>Vehicle Type</p>
                    <p>
                      {carInfo?.categories?.vehicleType}
                    </p>
                  </div>
                  <div className='flex justify-between border-b-[0.5px] border-[#7D7D7D] pb-3 mb-8 capitalize'>
                    <p>Driven Wheels</p>
                    <p>
                      {carInfo?.drivenWheels}
                    </p>
                  </div>
                  <div className='flex justify-between border-b-[0.5px] border-[#7D7D7D] pb-3 mb-8 capitalize'>
                    <p>City Mileage</p>
                    <p>
                      {carInfo?.mpg?.city} kmpl
                    </p>
                  </div>
                </div>
                <div className='text-lg w-1/2'>
                  <div className='flex justify-between border-b-[0.5px] border-[#7D7D7D] pb-3 mb-8'>
                    <p>Model Name</p>
                    <p>{carInfo?.model?.name}</p>
                  </div>
                  <div className='flex justify-between border-b-[0.5px] border-[#7D7D7D] pb-3 mb-8'>
                    <p>Vehicle Size</p>
                    <p>{carInfo?.categories?.vehicleSize}</p>
                  </div>
                  <div className='flex justify-between border-b-[0.5px] border-[#7D7D7D] pb-3 mb-8'>
                    <p>Number Of Doors</p>
                    <p>{carInfo?.numOfDoors}</p>
                  </div>
                  <div className='flex justify-between border-b-[0.5px] border-[#7D7D7D] pb-3 mb-8 capitalize'>
                    <p>Highway Mileage</p>
                    <p>
                      {carInfo?.mpg?.highway} kmpl
                    </p>
                  </div>
                </div>
                
              </div>


              <h2 className='underline font-medium text-xl pb-[40px] mt-10'>
              Engine & Transmission
              </h2>
              <div className='flex gap-16 font-normal '>
                <div className='text-lg w-1/2'>
                  <div className='flex justify-between border-b-[0.5px] border-[#7D7D7D] pb-3 mb-8'>
                    <p>Engine</p>
                    <p>{carInfo?.engine?.name} L</p>
                  </div>
                  <div className='flex justify-between border-b-[0.5px] border-[#7D7D7D] pb-3 mb-8 capitalize'>
                    <p>Displacement</p>
                    <p>
                      {carInfo?.engine?.displacement} CC
                    </p>
                  </div>
                  <div className='flex justify-between border-b-[0.5px] border-[#7D7D7D] pb-3 mb-8 capitalize'>
                    <p>Transmission</p>
                    <p>
                      {carInfo?.transmission?.transmissionType?.toLowerCase()}
                    </p>
                  </div>
                  <div className='flex justify-between border-b-[0.5px] border-[#7D7D7D] pb-3 mb-8 capitalize'>
                    <p>Number Of Speeds</p>
                    <p>
                      {carInfo?.transmission?.numberOfSpeeds}
                    </p>
                  </div>
                </div>
                <div className='text-lg w-1/2'>
                  <div className='flex justify-between border-b-[0.5px] border-[#7D7D7D] pb-3 mb-8'>
                    <p>Horsepower</p>
                    <p>{carInfo?.engine?.horsepower}hp@{carInfo?.engine?.rpm?.horsepower}rpm</p>
                  </div>
                  <div className='flex justify-between border-b-[0.5px] border-[#7D7D7D] pb-3 mb-8'>
                    <p>Torque</p>
                    <p>{carInfo?.engine?.torque}hp@{carInfo?.engine?.rpm?.horsepower}rpm</p>
                  </div>
                  <div className='flex justify-between border-b-[0.5px] border-[#7D7D7D] pb-3 mb-8'>
                    <p>Cylinders</p>
                    <p>{carInfo?.engine?.cylinder}</p>
                  </div>
                  <div className='flex justify-between border-b-[0.5px] border-[#7D7D7D] pb-3 mb-8'>
                    <p>Total Valves</p>
                    <p>{carInfo?.engine?.totalValves}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        {/* <div className='pb-[50px]'>
          <div className="bg-[url('/src/common/assets/images/productPageSummary1.png')]  min-h-[858px] py-7 bg-no-repeat bg-cover bg-center">
            <div className='px-[113px] '>
              <div className='flex gap-9 items-center'>
                <p className='font-semibold text-3xl'>
                  Vehicle History Report by
                </p>
                <img src={autoCheck} alt='' />
              </div>
              <div className='pt-[70px] px-20'>
                <div
                  className='flex justify-between items-center border-[0.5px] border-[#575757] p-[50px] bg-[#F3F4F4] mb-3'
                  style={{ boxShadow: '3px 2px 17px 0px #00000040' }}
                >
                  <p className='font-light text-3xl'>Market Value</p>
                  <img src={marketValue} alt='' />
                </div>
                <div
                  className='flex justify-between items-center border-[0.5px] border-[#575757] p-[50px] bg-[#F3F4F4] mb-3'
                  style={{ boxShadow: '3px 2px 17px 0px #00000040' }}
                >
                  <p className='font-light text-3xl'>Salvage Value</p>
                  <img src={salvageValue} alt='' />
                </div>
                <div
                  className='flex justify-between items-center border-[0.5px] border-[#575757] p-[50px] bg-[#F3F4F4] mb-3'
                  style={{ boxShadow: '3px 2px 17px 0px #00000040' }}
                >
                  <p className='font-light text-3xl'>insurance value</p>
                  <img src={insuranceValue} width={78} height={56} alt='' />
                </div>
                <div className='flex items-center gap-7'>
                  <p className='text-white pt-[50px] pb-5 text-3xl'>
                    Upgrade the membership to get these values
                  </p>
                  <img src={linkIcon} className='mt-7' alt='' />
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </Spin>
  );
};

export default Summary;
